import Warehouse from "../warehouse"
import { ZoneType } from "@ciq/shared/utils/const"
import { keyLoader } from "@ciq/shared/utils/object"

export class AccessPoint {
  constructor(data) {
    this.id = data?.id

    this.name = data?.name
    this.description = data?.description
    this.buildingId = keyLoader(data, ["buildingId", "building.id", "building_id"])
    this.floor = data?.floor
    this.has_geojson = keyLoader(data, ["has_geojson"])
    if (this.has_geojson == null) {
      this.has_geojson = false
    }
  }

  getBuilding() {
    if (!this.buildingId) {
      return null
    }

    return Warehouse.wireless_config.getBuildings().getById(this.buildingId)
  }

  getFloorZone() {
    if (this.buildingId == null || this.floor == null) {
      return null
    }

    return Warehouse.wireless_config
      .getZones()
      .getAll()
      .find(
        z =>
          z.type === ZoneType.FLOOR &&
          z.getBuilding()?.id === this.buildingId &&
          z.floors.includes(this.floor)
      )
  }

  isComplete() {
    return this.getFloorZone() != null && this.hasGeoJson()
  }

  hasParent() {
    return this.buildingId != null && this.floor != null
  }

  hasGeoJson() {
    return this.has_geojson
  }
}
